define('drops/captcha/captcha',[
    'jquery',
    'underscore',
    'lq',
    'lq/drop',
    'lq/style',
    'jquery.placeholder'
], function ($, _, lq, Drop, Style) {
    'use strict';
    
    function Captcha(options) {
        Drop.call(this, $('<div/>'), options);
        
        this.$image = $('<div />')
            .css({
                'width': '100%',
                'height': '100%',
                'overflow': 'hidden'
            })
            .attr('tabindex', this.data.tabIndex)
            .appendTo(this.$element);

        this.$element
            .addClass('boxToBorderSize');

        Style.renderStyles(this, null, this.$image);
    };

    Drop.extend(Captcha, Drop);

    Captcha.typeName = 'Captcha';

    Captcha.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.setACaptcha();
    };

    Captcha.prototype.setACaptcha = function () {
        this.$image
            .css({
                'background-image': 'url(' + this.createCaptchaUrl() + ')',
                'background-size': '100% 100%',
                'background-repeat': 'no-repeat'
            });
    };

    Captcha.prototype.createCaptchaUrl = function () {
        return lq.getTenantUrl('LicquidAction/Captcha?t=' + new Date().getTime());
    };
    
    Captcha.prototype.refreshCaptcha = function () {
        this.setACaptcha();
    };
    
    return Captcha;
});

